import React from 'react'
import BackgroundVideo from '../BackgroundVideo';
import About from '../components/About';
import { Achievements } from '../components/Achievements';
import { PlayVideo } from '../components/PlayVideo';
import { ExclusiveListing } from '../components/ExclusiveListing';

const Home = () => {
  return (
    <>
    <BackgroundVideo/>
      <About/>
      <Achievements/>
      <PlayVideo/>
      <ExclusiveListing/>
    </>
  )
}

export default Home